export enum TrackingUIType {
    Faq = 'faq',
    Footnote = 'footnote'
}
